<template>
  <div class="setting-base">
    <div
      class="item"
      @click="onClickItem(item)"
      v-for="item in titles"
      :key="item.type"
    >{{item.title}}</div>
  </div>
</template>

<script>
import createFullComp from "@/utils/createFullComp";
import BasicView from "./component/BasicView.vue";
export default {
  components: { BasicView },
  data() {
    return {
      titles: [
        { title: this.$t('moduleTitles.basicInfo'), type: "basic" },
        { title: this.$t('edit.editActionTitles.adsSets'), type: "ads" },
        { title: this.$t('edit.editActionTitles.menuSets'), type: "menu" },
        { title: this.$t('edit.editActionTitles.pwdSets'), type: "pwd" },
        { title: this.$t('edit.editActionTitles.funcSets'), type: "func" },
        { title: this.$t('edit.editActionTitles.startAnimation'), type: "StartAnimation" },
      ],
    };
  },
  methods: {
    onClickItem(item) {
      this.$emit("onClickTitle", item.type);
    },
  },
};
</script>

<style lang="less" scoped>
.setting-base {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .item {
    width: 62px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background-color: #5a5a5a;
    // color: rgba(45, 45, 45, 1);
    color: #ffffff;
    font-size: 12px;
    border-radius: 10px;
    /*margin-right: 10px;*/
  }
}
</style>